import { useMemo } from "react";
import {
  Background,
  Controls,
  ReactFlow,
  ReactFlowProvider,
  type Edge,
  type Node,
  type NodeTypes,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";

import GtmBranchNode from "./nodes/GtmBranchNode";
import GtmStepNode from "./nodes/GtmStepNode";
import GtmTerminalNode from "./nodes/GtmTerminalNode";
import GtmWaitNode from "./nodes/GtmWaitNode";
import type { GtmFlowNodeData } from "./sequenceToFlow";

const nodeTypes: NodeTypes = {
  gtmStep: GtmStepNode,
  gtmBranch: GtmBranchNode,
  gtmWait: GtmWaitNode,
  gtmTerminal: GtmTerminalNode,
};

type Props = {
  nodes: Node<GtmFlowNodeData>[];
  edges: Edge[];
  onNodeClick?: (nodeId: string, stepKey?: string) => void;
};

function SequenceFlowInner({ nodes, edges, onNodeClick }: Props) {
  const memoTypes = useMemo(() => nodeTypes, []);
  return (
    <ReactFlow
      nodes={nodes}
      edges={edges}
      nodeTypes={memoTypes}
      nodesDraggable={false}
      nodesConnectable={false}
      elementsSelectable
      panOnScroll
      fitView
      fitViewOptions={{ padding: 0.2 }}
      minZoom={0.4}
      maxZoom={1.5}
      proOptions={{ hideAttribution: false }}
      onNodeClick={(_e, node) => {
        const data = node.data as GtmFlowNodeData;
        onNodeClick?.(node.id, data.stepKey);
      }}
      className="bg-slate-50"
    >
      <Controls showInteractive={false} />
      <Background gap={16} size={1} color="#e2e8f0" />
    </ReactFlow>
  );
}

/** Read-only React Flow canvas for Play Sequence (story 11.13). Styles imported once here. */
export default function SequenceFlowCanvas(props: Props) {
  return (
    <div className="h-[420px] w-full overflow-hidden rounded-lg border border-gray-200">
      <ReactFlowProvider>
        <SequenceFlowInner {...props} />
      </ReactFlowProvider>
    </div>
  );
}
